import React from 'react'
import Footer from '../component/Footer'

const High = () => {
    return (
        <>
            <div className='heading'>
                <h1>High Risk Pregnancy </h1>
                <p>Home / High Risk Pregnancy</p>
            </div>

            <div className='desiese'>

                <div className='desiese1'>
                    <h1>What is High-Risk Pregnancy?</h1>

                    <p>Females can suffer from a high risk of pregnancy complications due to the following situations :</p>


                    <li>Weight of the females. Both, being underweight or overweight becomes an issue.</li>
                    <li>Age of the females. It is good to conceive at the right age, that is, females younger than 17 or older than 35 may have complications.</li>
                    <li>Pregnancy with triplets or twins.</li>
                    <li>Females who suffer from high blood pressure, thyroid, diabetes, and other health problems.</li>
                    <li>Serious issues like delivering a premature baby in the first pregnancy or have given birth to a child who has genetic disorders.</li>



                    <h1>How can a doctor help us in the health state of High-Risk Pregnancy?</h1>

                    <p>Our specialist Dr. Smiti will help females who suffer from High-Risk Pregnancy in the best possible way. She will closely monitor the patient in each term or month of pregnancy. Our doctor and the assisting staff will recommend the patient to eat a healthy and balanced diet.</p>
                    <p>The patient will be requested and guided to keep the infections and illnesses at bay. Alcohol, smoke, and meat will be immediately prohibited. And before anything else prevails, it will be the stress that needs to be reduced.</p>



                </div>


             
               
            </div>

            <br />

            <Footer />
        </>
    )
}

export default High